// // XpressBees API Functions

// // Function to generate token
// async function getToken(username, password, secretkey) {
//     try {
//         const response = await fetch('https://userauthapis.xbees.in/api/auth/generateToken', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer xyz'
//             },
//             body: JSON.stringify({
//                 username: username,
//                 password: password,
//                 secretkey: secretkey
//             })
//         });

//         const data = await response.json();
        
//         if (data.code === 200) {
//             console.log('Token generated successfully:', data);
//             return data.token;
//         } else {
//             console.error('Token generation failed:', data);
//             return null;
//         }
//     } catch (error) {
//         console.error('Error getting token:', error);
//         return null;
//     }
// }

// // Function to get shipment tracking data
// async function getShipmentTracking(token, awbNumber) {
//     try {
//         const response = await fetch('http://api.staging.shipmenttracking.xbees.in/GetShipmentAuditLog', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'token': token,
//                 'versionnumber': 'v1'
//             },
//             body: JSON.stringify({
//                 AWBNumber: awbNumber
//             })
//         });

//         const data = await response.json();
        
//         if (response.ok) {
//             console.log('Shipment tracking data:', data);
//             return data;
//         } else {
//             console.error('Tracking API failed:', data);
//             return null;
//         }
//     } catch (error) {
//         console.error('Error getting tracking data:', error);
//         return null;
//     }
// }

// // Main function to get token and track shipment
// async function trackShipmentWithToken(awbNumber) {
//     // Your credentials
//     const username = 'admin@djtsml.com';
//     const password = '$djtsml$';
//     const secretkey = 'da464ab89f3989c98cf6a54e8aea22e1a3da86aa566c7cfd0cdbe3851a01fe1b';
    
//     // Step 1: Get token
//     console.log('Generating token...');
//     const token = await getToken(username, password, secretkey);
    
//     if (!token) {
//         console.error('Failed to get token');
//         return null;
//     }
    
//     // Step 2: Track shipment
//     console.log('Tracking shipment:', awbNumber);
//     const trackingData = await getShipmentTracking(token, awbNumber);
    
//     return trackingData;
// }

// // Usage example:
// // Track specific AWB number
// trackShipmentWithToken('1537520000002').then(data => {
//     if (data) {
//         console.log('Final tracking result:', data);
//     }
// });

// // Alternative: If you already have a token, use this function directly
// async function trackWithExistingToken(token, awbNumber) {
//     return await getShipmentTracking(token, awbNumber);
// }

// // Example usage with existing token:
// // trackWithExistingToken('your_existing_token', '1537520000002');

























// Bhoopi api code





// XpressBees API - Complete Working Script
// Based on successful Postman/cURL testing

class XpressBeesAPI {
    constructor() {
        this.credentials = {
            username: "admin@djtsml.com",
            password: "$djtsml$",
            secretkey: "da464ab89f3989c98cf6a54e8aea22e1a3da86aa566c7cfd0cdbe3851a01fe1b"
        };
        this.token = null;
        this.tokenExpiry = null;
        this.baseUrls = {
            auth: "https://userauthapis.xbees.in/api/auth/generateToken",
            tracking: "https://apishipmenttracking.xbees.in/GetShipmentAuditLog",
            bulkTracking: "https://apishipmenttracking.xbees.in/GetCurrentShipmentStatus"
        };
    }

    // Generate authentication token
    async generateToken() {
        try {
            console.log("🔑 Generating authentication token...");
            
            const response = await fetch(this.baseUrls.auth, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.credentials)
            });

            const data = await response.json();
            
            if (data.token && data.code === 200) {
                this.token = data.token;
                // Tokens typically expire in 1 hour
                this.tokenExpiry = Date.now() + (60 * 60 * 1000);
                console.log("✅ Token generated successfully");
                return {
                    success: true,
                    token: data.token,
                    message: "Authentication successful"
                };
            } else {
                throw new Error(`Authentication failed: ${data.error || 'Unknown error'}`);
            }
        } catch (error) {
            console.error("❌ Token generation failed:", error.message);
            return {
                success: false,
                error: error.message
            };
        }
    }

    // Check if token is valid and not expired
    isTokenValid() {
        return this.token && this.tokenExpiry && Date.now() < this.tokenExpiry;
    }

    // Ensure we have a valid token
    async ensureValidToken() {
        if (!this.isTokenValid()) {
            const result = await this.generateToken();
            if (!result.success) {
                throw new Error(`Failed to get valid token: ${result.error}`);
            }
        }
    }

    // Track a single shipment
    async trackShipment(awbNumber) {
        try {
            console.log(`📦 Tracking shipment: ${awbNumber}`);
            
            await this.ensureValidToken();

            const response = await fetch(this.baseUrls.tracking, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': this.token,
                    'versionnumber': 'v1'
                },
                body: JSON.stringify({
                    AWBNumber: awbNumber
                })
            });

            const result = await response.json();
            
            if (result.ReturnCode === 200) {
                console.log(`✅ Tracking successful for AWB: ${awbNumber}`);
                return {
                    success: true,
                    awbNumber: awbNumber,
                    data: result.ShipmentLogDetails,
                    message: result.ReturnMessage || "Tracking successful"
                };
            } else if (result.ReturnCode === 404 || result.ReturnMessage.includes("not found")) {
                console.log(`⚠️ AWB not found: ${awbNumber}`);
                return {
                    success: false,
                    awbNumber: awbNumber,
                    error: "AWB number not found in system",
                    details: result.ReturnMessage
                };
            } else {
                console.log(`❌ Tracking failed for AWB: ${awbNumber} - ${result.ReturnMessage}`);
                return {
                    success: false,
                    awbNumber: awbNumber,
                    error: result.ReturnMessage,
                    returnCode: result.ReturnCode
                };
            }
        } catch (error) {
            console.error(`❌ Error tracking AWB ${awbNumber}:`, error.message);
            return {
                success: false,
                awbNumber: awbNumber,
                error: error.message
            };
        }
    }

    // Track multiple shipments
    async trackMultipleShipments(awbNumbers) {
        try {
            console.log(`📦 Tracking ${awbNumbers.length} shipments...`);
            
            await this.ensureValidToken();

            const response = await fetch(this.baseUrls.bulkTracking, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': this.token,
                    'versionnumber': 'v1'
                },
                body: JSON.stringify({
                    AWBNumbers: awbNumbers
                })
            });

            const result = await response.json();
            console.log("✅ Bulk tracking completed");
            
            return {
                success: true,
                requestedCount: awbNumbers.length,
                data: result,
                message: "Bulk tracking completed"
            };
        } catch (error) {
            console.error("❌ Bulk tracking failed:", error.message);
            return {
                success: false,
                error: error.message
            };
        }
    }

    // Utility method to validate AWB number format
    isValidAWBNumber(awbNumber) {
        // Basic validation - should be numeric and appropriate length
        const awbStr = String(awbNumber);
        return /^\d{10,15}$/.test(awbStr);
    }

    // Get tracking summary for display
    async getTrackingSummary(awbNumber) {
        const result = await this.trackShipment(awbNumber);
        
        if (result.success && result.data && result.data.length > 0) {
            const latestStatus = result.data[result.data.length - 1];
            return {
                awbNumber: awbNumber,
                status: latestStatus.StatusDescription || latestStatus.Status || "Unknown",
                location: latestStatus.Location || "Not available",
                timestamp: latestStatus.EventDateTime || latestStatus.Date || "Not available",
                isDelivered: latestStatus.StatusDescription && 
                           latestStatus.StatusDescription.toLowerCase().includes('delivered')
            };
        } else {
            return {
                awbNumber: awbNumber,
                status: "Not Found",
                location: "N/A",
                timestamp: "N/A",
                isDelivered: false,
                error: result.error
            };
        }
    }
}

// Usage Examples and Testing Functions
class XpressBeesHelper {
    constructor() {
        this.api = new XpressBeesAPI();
    }

    // Test with a single AWB number
    async testSingleTracking(awbNumber) {
        console.log(`\n🧪 Testing single AWB tracking: ${awbNumber}`);
        console.log("=" + "=".repeat(50));
        
        if (!this.api.isValidAWBNumber(awbNumber)) {
            console.log("❌ Invalid AWB number format");
            return;
        }

        const result = await this.api.trackShipment(awbNumber);
        console.log("Result:", JSON.stringify(result, null, 2));
        
        if (result.success) {
            console.log("\n📋 Shipment Details:");
            result.data.forEach((event, index) => {
                console.log(`${index + 1}. ${event.StatusDescription || event.Status} - ${event.Location || 'Unknown'}`);
            });
        }
    }

    // Test with multiple AWB numbers
    async testBulkTracking(awbNumbers) {
        console.log(`\n🧪 Testing bulk tracking: ${awbNumbers.length} AWBs`);
        console.log("=" + "=".repeat(50));
        
        const validAWBs = awbNumbers.filter(awb => this.api.isValidAWBNumber(awb));
        console.log(`Valid AWBs: ${validAWBs.length}/${awbNumbers.length}`);
        
        if (validAWBs.length === 0) {
            console.log("❌ No valid AWB numbers provided");
            return;
        }

        const result = await this.api.trackMultipleShipments(validAWBs);
        console.log("Result:", JSON.stringify(result, null, 2));
    }

    // Ask team for AWB numbers and test
    async askTeamForAWBNumbers() {
        console.log("\n📞 Request AWB Numbers from Team");
        console.log("=" + "=".repeat(50));
        console.log("Please ask your team to provide:");
        console.log("1️⃣ Recent AWB numbers for testing");
        console.log("2️⃣ Expected status of these shipments");
        console.log("3️⃣ Date range when shipments were created");
        console.log("\n💡 Suggested message to team:");
        console.log(`
"Hi Team,

I'm testing our XpressBees tracking API integration. 
Could you please provide:

1. 3-5 recent AWB numbers from our XpressBees account
2. Expected current status of these shipments
3. Date when these were shipped

This will help validate our tracking system is working correctly.

Thanks!"
        `);
        
        console.log("\n🔧 Once you get AWB numbers, test them with:");
        console.log("helper.testSingleTracking('YOUR_AWB_NUMBER')");
        console.log("helper.testBulkTracking(['AWB1', 'AWB2', 'AWB3'])");
    }

    // Quick health check
    async healthCheck() {
        console.log("\n🔍 API Health Check");
        console.log("=" + "=".repeat(30));
        
        const tokenResult = await this.api.generateToken();
        if (tokenResult.success) {
            console.log("✅ Authentication: Working");
            
            // Test with known testing AWB
            console.log("🧪 Testing with sample AWB...");
            const testResult = await this.api.trackShipment("1537520000000");
            
            if (testResult.success) {
                console.log("✅ Tracking API: Working");
            } else if (testResult.error === "AWB number not found in system") {
                console.log("✅ Tracking API: Working (test AWB not found - expected)");
            } else {
                console.log("⚠️ Tracking API: " + testResult.error);
            }
        } else {
            console.log("❌ Authentication: Failed");
        }
    }
}

// Initialize and make available globally
window.xpressAPI = new XpressBeesAPI();
window.helper = new XpressBeesHelper();

// Display usage instructions
console.log("🚀 XpressBees API Script Loaded Successfully!");
console.log("\n📋 Available Commands:");
console.log("=" + "=".repeat(40));
console.log("1️⃣ helper.healthCheck()                    - Check API status");
console.log("2️⃣ helper.askTeamForAWBNumbers()          - Get team instruction");
console.log("3️⃣ helper.testSingleTracking('AWB')       - Track one shipment");
console.log("4️⃣ helper.testBulkTracking(['AWB1','AWB2']) - Track multiple");
console.log("\n🏁 Quick Start:");
console.log("helper.healthCheck()");

// Auto-run health check
setTimeout(() => {
    console.log("\n🔄 Running automatic health check...");
    window.helper.healthCheck();
}, 2000);